import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { useIntl } from 'react-intl'
import { AddBoardMeetingBreadCrum, ComplianceMeetingBreadCrumbs, ComplianceMeetingDetailsBreadCrum } from './core/_constants'
import { ComplianceMeeting } from './view/compliance-meeting'
import MeetingInterface from './components/meeting-details'
import { AddBoardMeeting } from './view/add-board-meeting'
import AfterMeeting from './view/after-meeting'

const ComplianceMeetingRoute = () => {
  const { formatMessage } = useIntl()


  return (
    <div className='mt-3 px-6'>
      <Routes>
        <Route
          index
          element={
            <>
              <PageTitle
                breadcrumbs={ComplianceMeetingBreadCrumbs}
                description={formatMessage({ id: 'Compliance Meeting' })}
              >
                {formatMessage({ id: 'Compliance Meeting' })}
              </PageTitle>
              <ComplianceMeeting />
            </>
          }
        />
        <Route
          path='components/meeting-details'
          element={
            <>
              <PageTitle
                breadcrumbs={ComplianceMeetingBreadCrumbs}
                description={formatMessage({ id: 'Compliance Meeting' })}
              >
                {formatMessage({ id: 'Compliance Meeting' })}
              </PageTitle>
              <MeetingInterface />
            </>
          }
        />
        <Route
          path='view/add-board-meeting'
          element={
            <>
              <PageTitle
                breadcrumbs={AddBoardMeetingBreadCrum}
                description={formatMessage({ id: 'New Meeting' })}
              >
                {formatMessage({ id: 'New Meeting' })}
              </PageTitle>
              <AddBoardMeeting />
            </>
          }
        />
        <Route
          path='view/compliance-meeting-details'
          element={
            <>
              <PageTitle
                breadcrumbs={ComplianceMeetingDetailsBreadCrum}
                description={formatMessage({ id: 'Meeting Details' })}
              >
                {formatMessage({ id: 'Meeting Details' })}
              </PageTitle>
              <MeetingInterface />
            </>
          }
        />
        <Route
          path='view/after-meeting'
          element={
            <>
              <PageTitle
                breadcrumbs={ComplianceMeetingDetailsBreadCrum}
                description={formatMessage({ id: 'Meeting Details' })}
              >
                {formatMessage({ id: 'Meeting Details' })}
              </PageTitle>
              <AfterMeeting />
            </>
          }
        />
      </Routes>
    </div>
  )
}

export default ComplianceMeetingRoute
